(function() {
'use strict';
  
  angular.module('app.shell', [
    
  ]);
  
})();